import { ApolloCache } from '@apollo/client';

const deleteCachedObject = (cache: ApolloCache<any>, typename: string, id: string): void => {
  const normalizedCacheId = cache.identify({ id, __typename: typename });
  cache.evict({ id: normalizedCacheId });
  cache.gc();
};

export default deleteCachedObject;
